import React, { useMemo } from "react";

// Rising ember particles for hero background.
export default function FireParticles({ count = 28 }) {
  const embers = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const left = Math.random() * 100;
        const size = 3 + Math.random() * 6;
        const dur = 6 + Math.random() * 8;
        const delay = Math.random() * 8;
        const drift = (Math.random() - 0.5) * 120;
        return { left, size, dur, delay, drift, i };
      }),
    [count]
  );
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {embers.map((e) => (
        <span
          key={e.i}
          className="ember"
          style={{
            left: `${e.left}%`,
            width: e.size,
            height: e.size,
            animationDuration: `${e.dur}s`,
            animationDelay: `${e.delay}s`,
            "--x-drift": `${e.drift}px`,
          }}
        />
      ))}
    </div>
  );
}
